import { Button, Font, PageEmpty, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { usePermissions } from '@dms/hook'
import { AccessType } from 'zens-store'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  text: {
    textAlign: 'center',
  },
  block: {
    marginTop: Spacing.M,
  },
  highlight: {
    fontFamily: Font.medium,
  },
})

interface Props {
  companyId: number
  search?: string
}
const ScheduleEmpty = (props: Props) => {
  const { companyId, search } = props
  const { t } = useTranslation()
  const { hasPermission } = usePermissions(companyId)

  if (search) {
    return (
      <PageEmpty>
        <Text level={2}>
          <Trans>
            No results matching{' '}
            <Text level={2} style={styles.highlight}>
              {/* @ts-expect-error Typing of vars in trans not working correctly  */}
              {{ search }}
            </Text>
          </Trans>
        </Text>
        <Text style={[styles.text, styles.block]}>
          <Trans>Try adjusting search or filter to find what you're looking for.</Trans>
        </Text>
      </PageEmpty>
    )
  }
  return (
    <PageEmpty>
      <Text level={2}>
        <Trans>There's nothing here yet</Trans>
      </Text>
      {hasPermission(AccessType.Update, 'workspace') ? (
        <>
          <Text style={[styles.text, styles.block]}>
            <Trans>Add your first schedule and it will be listed here...</Trans>
          </Text>
          <Link href={`/companies/${companyId}/workspaces/schedules/add`} asChild>
            <Button title={t('Add schedule')} left="plus" />
          </Link>
        </>
      ) : (
        <Text style={[styles.text, styles.block]}>
          <Trans>When a schedule is added it will be listed here.</Trans>
        </Text>
      )}
    </PageEmpty>
  )
}

export default ScheduleEmpty
